// @flow
import * as React from 'react';
import { Formik, Form } from 'formik';
import type { FormikActions } from 'formik';
import * as Yup from 'yup';
import classNames from 'classnames';
// eslint-disable-next-line import/named
import type { IntlShape } from 'react-intl';

//  Components
import { Container, Row, Col } from 'reactstrap';
import Button from 'components/atoms/Button';
import { TextField, FormikField } from 'components/api';

// Utils
import { isObjEmpty } from 'utils/varValidation';

import './PromoCode.scss';

const ns = 'promo-code';

type Props = {
  vehicle: Object,
  getFirstPromotion: (vin?: string, promoCode?: string) => Object,
  setActivePromotion: Object => void,
  closePromoCodeModal: () => void,
  intl: IntlShape
};

type State = {
  invalidPromoCode: boolean
};

type Values = {
  promoCode: string
};

const validationSchema = Yup.object().shape({
  promoCode: Yup.string()
});

class PromoCode extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    (this: any).onSubmit = this.onSubmit.bind(this);
    (this: any).state = {
      invalidPromoCode: false
    };
  }

  initialValues = {
    promoCode: ''
  };

  async onSubmit(values: Values, actions: FormikActions<Values>) {
    const { promoCode } = values;
    const { setSubmitting, setStatus, resetForm } = actions;
    const {
      vehicle: { vin },
      getFirstPromotion,
      setActivePromotion,
      closePromoCodeModal
    } = this.props;
    const promo = await getFirstPromotion(vin, promoCode);
    const success = Boolean(promo);
    setSubmitting(false);
    setStatus({ success });
    if (success) {
      resetForm(this.initialValues);
      setActivePromotion(promo);
      closePromoCodeModal();
    }
    this.setState({
      invalidPromoCode: !success
    });
  }

  handleFocus() {
    this.setState({
      invalidPromoCode: false
    });
  }

  render() {
    const { invalidPromoCode } = this.state;
    const classNameInvalidPromo = classNames({
      [`${ns}__invalid-promo--hidden`]: !invalidPromoCode,
      [`${ns}__invalid-promo`]: invalidPromoCode
    });
    const { intl } = this.props;
    return (
      <Formik
        initialValues={this.initialValues}
        validationSchema={validationSchema}
        onSubmit={this.onSubmit}
        render={({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          isSubmitting,
          dirty
        }) => {
          const disabled = !dirty || !isObjEmpty(errors);
          const { closePromoCodeModal } = this.props;
          return (
            <Container className={ns}>
              <Row>
                <Col className={`${ns}__card d-flex flex-column`}>
                  <h1 className={`${ns}__title align-self-center`}>
                    {intl.formatMessage({
                      id: 'c8.review.modal.promo.enter.promo.code'
                    })}
                  </h1>
                  <div className={`${classNameInvalidPromo} align-self-center`}>
                    {intl.formatMessage({
                      id: 'c8.review.modal.promo.invalid.promo.code'
                    })}
                  </div>

                  <Form onSubmit={handleSubmit}>
                    <FormikField
                      className={`${ns}__promo-code-field`}
                      renderedComponent={TextField}
                      name="promoCode"
                      placeholder={intl.formatMessage({
                        id: 'c8.review.modal.promo.promo.code'
                      })}
                      onFocus={() => this.handleFocus()}
                      aria-label={intl.formatMessage({
                        id: 'c8.aria.enter.promo.code',
                        defaultMessage: 'Introduce your promotion code'
                      })}
                    />
                    <div className={`d-flex flex-column`}>
                      <Button
                        className={`${ns}__change-password-button align-self-center`}
                        disabled={disabled}
                        type="Submit"
                      >
                        <div className={`py-2`}>
                          {intl.formatMessage({
                            id: 'c8.review.modal.promo.apply.code'
                          })}
                          {isSubmitting && (
                            <div className="ld ld-ring ld-spin-fast" />
                          )}
                        </div>
                      </Button>
                      <Button
                        buttonTheme="link"
                        onClick={() => {
                          closePromoCodeModal();
                        }}
                      >
                        {intl.formatMessage({
                          id: 'c8.common.cancel'
                        })}
                      </Button>
                    </div>
                  </Form>
                </Col>
              </Row>
            </Container>
          );
        }}
      />
    );
  }
}

export default PromoCode;



// WEBPACK FOOTER //
// ./src/components/pages/ReviewPage/components/PromoCode/PromoCode.js